module.exports = __webpack_public_path__ + "static/media/pinLocation.ee2e712a.svg";